export interface AddressCompanySettings {
    company_lookup?: boolean
    kvkNummer?: string | null
    vestigingsnummer?: string | null
    naam?: string | null
    straatnaam?: string | null
    plaats?: string | null
    type?: string | null
    huisnummer?: string | null
    huisletter?: string | null
    adres_type?: string | null
    location?: string | null
    postcode?: string | null
}

export interface DisplayItemWithSettings {
    settings?: {
        company_lookup?: boolean
    }
}

export const shouldTriggerCompanyAutoFill = (
    addressCompanySettings: AddressCompanySettings | null | undefined,
    item: DisplayItemWithSettings | null | undefined
): boolean => {
    return (
        addressCompanySettings?.company_lookup === true &&
        item?.settings?.company_lookup === true
    )
}

export const autoFillCompanyFields = (
    settings: AddressCompanySettings,
    value: any,
    currentRef: Record<string, any>
): void => {
    for (const [key, setting] of Object.entries(settings)) {
        if (key === 'company_lookup' || setting == null) {
            continue
        }

        const fieldRef = currentRef[`ddiRef${setting}`]?.current?.ddiRef
        if (!fieldRef) continue

        if (!value) {
            fieldRef.current.setVal('value', '')
            continue
        }

        const { adres = {}, geoData = {} } = value
        const { binnenlandsAdres = {} } = adres

        let fieldValue: any = value[key]

        switch (key) {
            case 'adres_type':
                fieldValue = binnenlandsAdres?.type
                break
            case 'plaats':
            case 'straatnaam':
                fieldValue = binnenlandsAdres?.[key]
                break
            case 'location':
                fieldRef.current.setVal(
                    'latitude',
                    geoData?.gpsLatitude ?? ''
                )
                fieldRef.current.setVal(
                    'longitude',
                    geoData?.gpsLongitude ?? ''
                )
                continue
            default:
                break
        }

        fieldRef.current.setVal(
            'value',
            fieldValue !== undefined ? fieldValue : ''
        )
    }
}
